module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073d2_banner_800x600.30a1223d.png";